import httpClient from "@/api/http-client";

const ENDPOINT = "/evento/carrera/talla-camiseta";

export interface TallaCamisetaDto {
  id?: number;
  stockBase: number;
  stockSequence: number;
  articuloInventario?: {
    estadoStock: string;
    estadoStockDisplay: string;
  };
  estado?: string;
  talla: {
    id: number;
    nombre: string;
    descripcion: string;
  };
}

export interface TallaCamisetaEditDto {
  tallasCamisetas: TallaCamisetaDto[];
}

class TallaCamisetaCarreraService {
  getTallas(idCarrera: string) {
    return httpClient.get(`${ENDPOINT}/${idCarrera}`).then(response => {
      if (response.data) {
        return response.data;
      } else {
        return [];
      }
    });
  }

  getTallasEditables(idCarrera: string) {
    return httpClient
      .get(`${ENDPOINT}/editable/${idCarrera}`)
      .then(response => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      });
  }

  saveTallasEditables(idCarrera: string, editDto: TallaCamisetaEditDto) {
    return httpClient.put(`${ENDPOINT}/editable/${idCarrera}`, editDto);
  }

  /**
   * 
   * @param idCarrera 
   * @returns 
   */
  getTallasRestantes(idCarrera: string | number) {
    return httpClient.get(`${ENDPOINT}/editable/${idCarrera}/restantes`).then(response => {
      if (response.data) {
        return response.data;
      } else {
        return [];
      }
    });
  }

  /**
   * 
   * @param idCarrera 
   * @param idTalla 
   * @returns 
   */
  deleteTallaCamiseta(idCarrera: string | number, idTallaCamisetaCarrera: string | number) {
    return httpClient.delete(`${ENDPOINT}/editable/${idCarrera}/eliminar/${idTallaCamisetaCarrera}`)
    .then(response => {
      if (response.data) {
        return response.data;
      }
    });
  }
}

export default new TallaCamisetaCarreraService();
